import { Injectable } from "@angular/core";
import moment from "moment";

@Injectable({
	providedIn: "root"
})
export class HelperService {
	// constructor(private snotifyService: SnotifyService) {}

	serializeData(data) {
		if (typeof data !== "object") {
			return data == null ? "" : data.toString();
		}

		let buffer = [];

		for (let name in data) {
			if (!data.hasOwnProperty(name)) {
				continue;
			}
			let value = data[name];
			buffer.push(encodeURIComponent(name) + "=" + encodeURIComponent(value == null ? "" : value));
		}

		let source = buffer.join("&").replace(/%20/g, "+");
		return source;
	}

	sayIt(text: string, lang: string) {
		if (window.speechSynthesis) {
			let language;
			switch (lang) {
				case "es":
					language = "es-ES";
					break;
				case "en":
					language = "en-US";
					break;

				default:
					language = "es-ES";
					break;
			}

			let speech = new SpeechSynthesisUtterance();
			speech.text = text;
			speech.volume = 1;
			speech.rate = 1;
			speech.pitch = 1;
			speech.lang = language;

			window.speechSynthesis.speak(speech);
		} else {
			console.log("speechSynthesis no soportado");
		}
	}

	numberFormat(
		number: number,
		decimals: number = 2,
		decimalSeparator: string = ".",
		thousandsSeparator: string = ","
	): string {
		if (!number) return "";

		const fixedNumber = number.toFixed(decimals);
		const [integerPart, decimalPart] = fixedNumber.split(".");

		const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);
		const formattedDecimalPart = decimalPart ? decimalSeparator + decimalPart : "";

		return formattedIntegerPart + formattedDecimalPart;
	}

	dateFormat(date: string, format: string): string {
		let dateFormat = "";
		if (date) {
			let momentDate = moment(date);
			dateFormat = momentDate.format(format);
		}

		return dateFormat;
	}

	moneyFormat(number: number) {
		const formatter = new Intl.NumberFormat("es-ES", {
			style: "currency",
			currency: "EUR"
		});

		return formatter.format(number);
	}

	// showNotificacion(tipo: "info" | "success" | "error" | "warning", titulo: string, mensaje: string) {
	// 	const options = {
	// 		timeout: 0,
	// 		showProgressBar: false,
	// 		closeOnClick: true,
	// 		pauseOnHover: true,
	// 		position: SnotifyPosition.rightTop,
	// 	};

	// 	switch (tipo) {
	// 		case "info":
	// 			this.snotifyService.info(mensaje, titulo, options);
	// 			break;

	// 		case "success":
	// 			this.snotifyService.success(mensaje, titulo, options);
	// 			break;

	// 		case "error":
	// 			this.snotifyService.error(mensaje, titulo, options);
	// 			break;

	// 		case "warning":
	// 			this.snotifyService.warning(mensaje, titulo, options);
	// 			break;

	// 		default:
	// 			break;
	// 	}
	// }
}
